export default __webpack_public_path__ + "static/media/omnes_light-webfont.43a3a8ad.woff";